import { SET_VALUES_SETTINGS } from '@constants/actionType'

const initialState = {
  loading: false,
  isFullAdmin: false
}

function settings(state = initialState, actions) {
  switch (actions.type) {
    case SET_VALUES_SETTINGS:
      return { ...state, ...actions.payload };
    default:
      return state
  }
}

export default settings